// technologies.jsx
import React from 'react';
import './technologies.css';
import Sidebar from '../sidebar/sidebar';
import image from "../../assets/Large-screens/5.png"


const Technologies = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Technologies"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default Technologies;
